import { useState } from "react";
import Sidebar, { TopBar } from "../components/Sidebar";
import UserList from "./UserList";
import UserDetail from "./UserDetail";
import EPDSManagement from "./EPDSManagement";
import SystemEvaluationSummary from "./SystemEvaluationSummary";
import MessagesPage from "./MessagesPage";
import EducationPage from "./EducationPage";
import DashboardHome from "./DashboardHome";
import PopulationAnalysis from "./PopulationAnalysis";

export default function Dashboard({ user, onLogout }) {
  const [view, setView] = useState("dashboard");
  const [selectedUser, setSelectedUser] = useState(null);
  const [msgUser, setMsgUser] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSelectUser = (u) => setSelectedUser(u);
  const handleBack = () => setSelectedUser(null);

  const handleSendMessage = (u) => {
    setMsgUser(u);
    setView("messages");
    setSelectedUser(null);
  };

  const handleNavigate = (id) => {
    setView(id);
    setSelectedUser(null);
    if (id !== "messages") setMsgUser(null);
  };

  const renderContent = () => {
    if (view === "users") {
      if (selectedUser) {
        return (
          <UserDetail
            user={selectedUser}
            onBack={handleBack}
            onSendMessage={handleSendMessage}
          />
        );
      }
      return <UserList onSelectUser={handleSelectUser} />;
    }
    if (view === "epds") return <EPDSManagement />;
    if (view === "system-evaluation") return <SystemEvaluationSummary />;
    if (view === "messages") return <MessagesPage preSelectedUser={msgUser} />;
    if (view === "education") return <EducationPage />; // ← tambah ini
    if (view === "dashboard") return <DashboardHome />;
    if (view === "population") return <PopulationAnalysis />;
    return null;
  };

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      <Sidebar
        active={view}
        onNavigate={handleNavigate}
        user={user}
        onLogout={onLogout}
        mobileOpen={mobileOpen}
        onMobileToggle={() => setMobileOpen(!mobileOpen)}
      />
      <main className="flex-1 overflow-y-auto">
        <TopBar onMobileToggle={() => setMobileOpen(!mobileOpen)} />
        <div className="pt-14 lg:pt-0 min-h-full">{renderContent()}</div>
      </main>
    </div>
  );
}
